import React, { useEffect, useMemo, useRef, useState } from 'react'
import '../../css/hosming/user_styles.css'

import MenuIcon from '@mui/icons-material/Menu';
import StarIcon from '@mui/icons-material/Star';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';

import { ImagenesGlobal } from '../global/ImagenesGlobal';
import { ProfileContent, short_logo_hosming, useProovedorData } from '../../components';
import ReplyIcon from '@mui/icons-material/Reply';

import imagen_mantenimiento from "../../images/mantenimiento.png";
import img1 from '../../temp_imgs/63ba370f0af9b633c3252ed6f00feab5aa0157a4.png';
import img2 from '../../temp_imgs/9ea44d5d01e1b9ca4f6c8cbefd47006b99904826.png';
import img3 from '../../temp_imgs/b36bd9391ffda64eb995ae328d2b5f2de43ddae5.jpg';
import hosming_icon from '../../images/Hosming_Icon.png';


import StorefrontIcon from '@mui/icons-material/Storefront';
import InfoIcon from '@mui/icons-material/Info';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PublicationIcon from '../../svg/PublicationIcon';

import HomeIcon from '@mui/icons-material/Home';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LoginIcon from '@mui/icons-material/Login';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import DragDown from '../../svg/DragDown';

import Profile from '../../pages/user/Profile';
import Publications from '../../pages/user/Publications';
import Catalog from '../../pages/user/Catalog';
import Curriculum from '../../pages/user/Curriculum';
import Favorites from '../../pages/user/Favorites';
import Gallery from '../../pages/user/Gallery';

import UserSubNavbar from '../user/UserSubNavbar';
import CallApi from '../../data/CallApi';
import ButtonLoader from '../global/ButtonLoader';

const style_icons = { color: 'var(--color-white)', fontSize: 'var(--size-icon-user)', width: 'var(--size-icon-user)' };

const list_colors = [
  '#DE6B08',
  '#FF0000',
  '#FFAE00',
  '#00BBFF',
  '#299900',
  '#FF9A94',
  '#B77519',
  '#FFC300',
  // #020202ff
  // #FF9A94
  // #B77519
];

const NavbarUser = () => {
  const key_user = null;
  const locationReact = useLocation();
  const { loadImageS, data_user, handleLogout, globalLoaders } = useProovedorData() ?? [];
  const { main_direc } = useParams();

  const userKey = new URLSearchParams(locationReact.search).get('authCode');

  const [currentUser, setCurrentUser] = useState({
    loading: false
  });

  async function getUserData() {
    const uk = userKey ?? 'me';// user key

    if (uk == 'me') return setCurrentUser(data_user);
    if (currentUser.loading) return;

    setCurrentUser({ loading: true });

    const fetch_user = await CallApi({
      url: 'api/user/profile?authCode=' + uk
    });

    setCurrentUser({ ...fetch_user, loading: false });
  }

  const arrayElementsRef = useRef({
    template: null,
    deskMenu: null,
    mobileMenu: null,
  });

  const [heightNav, setHeightNav] = useState({
    template: 0,
    deskMenu: 0,
    mobileMenu: 0,
  });

  const [userTemplate, seUserTemplate] = useState({
    template: 0,
    color: 0
  });

  const [templateSelected, setTemplateSelected] = useState(userTemplate.template);
  const [colorSelected, setColorSelected] = useState(userTemplate.color);

  const startY = useRef(null);

  const handleTouchStart = (e) => {
    startY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    if (startY.current === null) return;

    const endY = e.changedTouches[0].clientY;
    const distance = endY - startY.current;

    const MIN_SWIPE_DISTANCE = 40;

    if (distance > MIN_SWIPE_DISTANCE || distance < -MIN_SWIPE_DISTANCE) toggleExpandGeneral('template');

    startY.current = null;
  };


  const itsDifferent = useMemo(() => {
    return (
      userTemplate.template !== templateSelected ||
      userTemplate.color !== colorSelected
    );
  }, [userTemplate, templateSelected, colorSelected]);

  function saveChanges() {
    if (!itsDifferent) return;

    seUserTemplate({
      template: templateSelected,
      color: colorSelected
    });

    const root = document.documentElement;
    root.style.setProperty('--theme-user', list_colors[colorSelected] ?? '#989d96');
  }

  const toggleExpandGeneral = (type = null) => {
    if (type == null || !['template', 'deskMenu', 'mobileMenu'].includes(type)) return;

    if (arrayElementsRef.current) {
      const elementRotate = document.getElementById('drag-bottom-icon');
      setHeightNav((current_obj) => ({ ...current_obj, [type]: heightNav?.[type] == 0 ? arrayElementsRef.current[type].scrollHeight : 0 }));

      if (elementRotate && type == 'template') elementRotate.style.transform = heightNav?.[type] == 0 ? 'rotateZ(180deg)' : 'rotateZ(0deg)';
    }
  }

  const returnView = useMemo(() => {
    const mantenimiento = (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center', justifyContent: 'center', textAlign: 'center', width: '100%', padding: '15px' }}>
        <img src={imagen_mantenimiento} style={{ minWidth: '300px', width: '350px', maxWidth: '600px' }} />
        <h2 className='h2-mant'>
          Bienvenido...
        </h2>

        <p className='p-mant'>
          Nuestro sitio web está en construcción, estamos trabajando muy duro para brindarle la mejor experiencia con este.
        </p>
      </div>
    );

    switch (String(main_direc ?? "").toLowerCase()) {
      case "profile":
        // return <Profile />;
        return mantenimiento;
      case "posts":
        return <Publications />;
      case "catalog":
        return mantenimiento;
      // return <Catalog />;
      case "curriculum":
        return mantenimiento;
      // return <Curriculum />;
      case "gallery":
        return mantenimiento;
      // return <Gallery />;
      case "videos":
        return <UserSubNavbar />;
      case "favorites":
        return mantenimiento;
      // return <Favorites />;
      default:
        return mantenimiento;
      // return <div>En construcción</div>;
    }
  }, [main_direc]);

  const navStyleIcons = { color: 'var(--color-white)', width: '100%', height: '100%' };

  useEffect(() => {
    getUserData();
  }, [data_user, userKey]);

  return (
    <>
      <div id='templates-user' ref={(e) => arrayElementsRef.current.template = e} style={{ maxHeight: `${heightNav?.template ?? 0}px` }}>
        <div>
          <div className='template-container'>
            <img src={img1} className={templateSelected == 0 ? 'temp-selected' : ''} style={{ width: '250px' }} onClick={() => setTemplateSelected(0)} />
            <img src={img2} className={templateSelected == 1 ? 'temp-selected' : ''} style={{ width: '250px' }} onClick={() => setTemplateSelected(1)} />
            <img src={img3} className={templateSelected == 2 ? 'temp-selected' : ''} style={{ width: '250px' }} onClick={() => setTemplateSelected(2)} />

            <button
              className={'default-buttons' + (itsDifferent ? '-animation' : '')}
              style={{ backgroundColor: itsDifferent ? 'var(--empresa-color)' : 'var(--backgroundColor-button-normal)' }}
              onClick={saveChanges}
            >
              Guardar Cambios
            </button>
          </div>
          <hr></hr>
          <ul className='template-container'>
            {
              list_colors.map((color, index) => (
                <li onClick={() => setColorSelected(index)}>
                  <span className={colorSelected == index ? 'temp-selected' : ''} style={{ '--circle-color': color, borderWidth: '4px' }}></span>
                </li>
              ))
            }
          </ul>
        </div>
      </div>

      <nav class="nav-user-desktop">
        <div className='menu-icon'>
          <button className="default-buttons" onClick={() => toggleExpandGeneral('deskMenu')}>
            <MenuIcon style={{ color: 'var(--color-white)', fontSize: '60px' }} />
          </button>

          <div id='container-fum' ref={(e) => arrayElementsRef.current.deskMenu = e} style={{ maxHeight: `${heightNav?.deskMenu ?? 0}px` }}>
            <ul className='floating-user-menu'>
              <li className='shadow-lvl2-bottom' style={{ padding: '0px' }}>
                <NavLink
                  to='/'
                  onClick={() => toggleExpandGeneral('deskMenu')}
                  style={{
                    display: 'block',
                    width: '75%',
                    height: '75%',
                    borderRadius: '50%',
                    backgroundColor: 'var(--color-white)'
                  }}
                >
                  <img src={hosming_icon} style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center' }} />
                  {/* <ProfileContent profile_url={currentUser?.perfil} loadImageS={loadImageS} /> */}
                </NavLink>
              </li>

              <li className='shadow-lvl2-bottom' >
                <NavLink
                  to={{ pathname: "/user/posts", search: locationReact.search }}
                  onClick={() => toggleExpandGeneral('deskMenu')}
                >
                  <PublicationIcon color='var(--color-white)' main_css={{ width: '100%', height: '100%' }} />
                </NavLink>
              </li>

              <li className='shadow-lvl2-bottom' >
                <NavLink
                  to={{ pathname: "/user/catalog", search: locationReact.search }}
                  onClick={() => toggleExpandGeneral('deskMenu')}
                >
                  <StorefrontIcon style={navStyleIcons} />
                </NavLink>
              </li>

              <li className='shadow-lvl2-bottom' >
                <NavLink
                  to={{ pathname: "/user/curriculum", search: locationReact.search }}
                  onClick={() => toggleExpandGeneral('deskMenu')}
                >
                  <InfoIcon style={navStyleIcons} />
                </NavLink>
              </li>

              <li className='shadow-lvl2-bottom' >
                <NavLink
                  to={{ pathname: "/user/gallery", search: locationReact.search }}
                  onClick={() => toggleExpandGeneral('deskMenu')}
                >
                  <PhotoSizeSelectActualIcon style={navStyleIcons} />
                </NavLink>
              </li>

              <li className='shadow-lvl2-bottom' >
                <NavLink
                  to={{ pathname: "/user/videos", search: locationReact.search }}
                  onClick={() => toggleExpandGeneral('deskMenu')}
                >
                  <PlayCircleIcon style={navStyleIcons} />
                </NavLink>
              </li>

              <li className='shadow-lvl2-bottom' >
                <NavLink
                  to={{ pathname: "/user/favorites", search: locationReact.search }}
                  onClick={() => toggleExpandGeneral('deskMenu')}
                >
                  <BookmarkIcon style={navStyleIcons} />
                </NavLink>
              </li>
            </ul>
          </div>
        </div>


        <div className="user-section">
          <div className="avatar-circle">
            <ProfileContent profile_url={currentUser?.perfil} loadImageS={loadImageS} />
          </div>

          <div className="user-details">
            <span className="user-name">{currentUser?.fullname ?? 'Cargando...'}</span>
            <div className="user-actions">
              <div className="action-btn">
                <StarIcon style={{ color: 'var(--color-white)', fontSize: '28px' }} />
                Favoritos
              </div>
              <div className="action-btn">
                <ReplyIcon style={{ color: 'var(--color-white)', fontSize: '28px', transform: 'scaleX(-1)' }} />
                Compartir
              </div>
            </div>
          </div>
        </div>

        <div className="search-container">
          <div className="search-bar-user">
            <input type="text" placeholder="Buscar..." />

            <button className='default-buttons' style={{ height: 'min-content', position: 'absolute', right: '10px', transform: 'translateY(-50%)', top: '50%' }}>
              <SearchIcon style={{ color: 'var(--backgroundColor-button-normal)', fontSize: '28px' }} />
            </button>
          </div>

          <button className='default-buttons-animation arrow-up-circle' onClick={() => toggleExpandGeneral('template')}>
            {
              heightNav?.template == 0 ? (
                <ExpandMoreIcon style={{ color: '#d32f2f', fontSize: '28px' }} />
              ) : (
                <ExpandLessIcon style={{ color: '#d32f2f', fontSize: '28px' }} />
              )
            }
          </button>
        </div>

        <div className="right-side-group">
          <div className="logo-bracket-container">
            <span className="logo-text-font">Tu logo aqui</span>
          </div>
          <div className="stats-grid">
            <div className="stat-box">
              <span className="stat-val">36</span>
              <span className="stat-lab">Comentario</span>
            </div>
            <div className="stat-box">
              <span className="stat-val">0</span>
              <span className="stat-lab">Me gusta</span>
            </div>
            <div className="stat-box">
              <span className="stat-val">35</span>
              <span className="stat-lab">Vistas</span>
            </div>
            <div className="stat-box">
              <span className="stat-val">2</span>
              <span className="stat-lab">Compartidos</span>
            </div>
          </div>
        </div>
      </nav>

      <nav className='nav-user-mobile'>
        <div className='num-content'>
          <div id='num-images'>
            <NavLink to={'/'}>
              <button className="hosming-short">
                <img src={short_logo_hosming} />
              </button>
            </NavLink>

            <ImagenesGlobal url={null} className='shadow-lvl2-bottom' type='cover' alt={'Portada usuario ' + (key_user ?? '')} loadImageS={loadImageS} style={{ borderRadius: '12px' }} />
          </div>

          <button className='default-buttons' style={{ height: 'min-content' }}>
            <NotificationsIcon style={{ ...style_icons, color: 'var(--theme-user)' }} />
          </button>

          <button className='default-buttons drag-button-bottom' onClick={() => toggleExpandGeneral('template')} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
            <DragDown color='var(--theme-user)' main_css={{ width: '18px' }} />
          </button>
        </div>

        <ul>
          <li>
            <NavLink to={{ pathname: "/user/profile", search: locationReact.search }}>
              <HomeIcon style={style_icons} />
            </NavLink>
          </li>
          <li>
            <NavLink to={{ pathname: "/user/catalog", search: locationReact.search }}>
              <StorefrontIcon style={style_icons} />
            </NavLink>
          </li>
          <li>
            <NavLink to={{ pathname: "/user/posts", search: locationReact.search }}>
              <PublicationIcon style={style_icons} color={style_icons.color} />
            </NavLink>
          </li>
          <li>
            <NavLink to={{ pathname: "/user/videos", search: locationReact.search }}>
              <PlayCircleIcon style={style_icons} />
            </NavLink>
          </li>
          <li><SearchIcon style={style_icons} /></li>
          <li style={{ position: 'relative' }}>
            <button className='default-buttons' style={{ height: 'min-content', width: '40px' }} onClick={() => toggleExpandGeneral('mobileMenu')}>
              <ProfileContent profile_url={currentUser?.perfil} loadImageS={loadImageS} />
            </button>

            <div className='drop-down-user-mobile' ref={(e) => arrayElementsRef.current.mobileMenu = e} style={{ maxHeight: `${heightNav?.mobileMenu ?? 0}px` }}>
              <ul>
                <li>
                  <NavLink to={{ pathname: "/user/curriculum", search: locationReact.search }}>
                    <InfoIcon style={style_icons} />
                  </NavLink>
                </li>
                <li >
                  <NavLink to={{ pathname: "/user/gallery", search: locationReact.search }}>
                    <PhotoSizeSelectActualIcon style={style_icons} />
                  </NavLink>
                </li>
                <li>
                  <NavLink to={{ pathname: "/user/favorites", search: locationReact.search }}>
                    <BookmarkIcon style={style_icons} />
                  </NavLink>
                </li>
                <li>
                  <ButtonLoader className='default-buttons' type='button' onClick={handleLogout} state_progress={globalLoaders?.login} colorProgress='var(--color-white)'>
                    <LoginIcon style={style_icons} />
                  </ButtonLoader>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>

      <div className='view-user'>
        {returnView}
      </div>
    </>
  )
}

export default NavbarUser